var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Accordion, AccordionDetails, AccordionSummary, AppBar, Button, Card, Container, Dialog, Grid, IconButton, makeStyles, TextField, Toolbar, Typography } from '@material-ui/core';
import { CheckCircleRounded, Close, ExpandMore } from '@material-ui/icons';
import moment from 'moment';
import { SnackbarProvider, useSnackbar } from 'notistack';
import React, { useMemo, useState } from 'react';
import { pluralizeDays, pluralizePersons, _T } from '../../../include/appI18n';
import { api } from '../../../include/network/network';
import { appUrl, isValidEmail } from '../../../include/utils';
import { _ParentFrame } from '../types/Frame';
const useStyles = makeStyles(theme => ({
    tourOrderTableTourname: {
        [theme.breakpoints.up("lg")]: {
            width: '360px'
        }
    },
    tourOrderTableCheckindate: {
        [theme.breakpoints.up("lg")]: {
            width: '80px'
        }
    },
    tourOrderTableCheckoutdate: {
        [theme.breakpoints.up("lg")]: {
            width: '80px'
        }
    },
    tourOrderTableDuration: {
        [theme.breakpoints.up("lg")]: {
            width: '240px'
        }
    },
    tourOrderTablePrice: {
        [theme.breakpoints.up("lg")]: {
            width: '80px'
        }
    },
    tourOrderTablePersons: {
        [theme.breakpoints.up("lg")]: {
            width: '120px'
        }
    },
    tourOrderTableAvailability: {
        textAlign: 'center',
        [theme.breakpoints.up("lg")]: {
            width: '120px'
        }
    },
    orderInfo: {
        '& td': {
            paddingTop: '20px',
            '&:first-child': {
                paddingLeft: '20px',
            }
        },
    },
    tableResponsive: {
        minHeight: '.01%',
        overflowX: 'auto',
        '&  > .table > thead > tr > th, & > .table > tbody > tr > th, & > .table > tfoot > tr > th, & > .table > thead > tr > td, & > .table > tbody > tr > td, & > .table > tfoot > tr > td': {
            whiteSpace: 'normal'
        }
    },
    orderTable: {
        fontSize: '11px',
        paddingLeft: '20px',
        paddingRight: '20px',
        marginBottom: 0,
        borderTop: '1px solid #e6e6e6 !important',
        width: '100%',
        maxWidth: '100%',
        '& thead': {
            backgroundColor: '#767676',
            color: '#fff',
            textTransform: 'uppercase',
            '& tr th': {
                padding: '4px',
                lineHeight: 1.5,
                fontWeight: 400,
                borderBottom: 0,
                verticalAlign: 'baseline',
                '& img, & .fa': {
                    width: '30px',
                    marginRight: '10px',
                    display: 'none',
                    fonhtSize: '2.5em',
                    [theme.breakpoints.up("md")]: {
                        display: 'inline-block',
                    },
                },
                '&:first-child': {
                    paddingLeft: '20px',
                }
            },
            '& tr td': {
                border: 'none',
                '&:first-child': {
                    paddingLeft: '20px',
                }
            },
        },
    },
    cart: {},
    hotelBody: {
        backgroundColor: '#fff',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingTop: '60px',
        paddingBottom: '25px',
    },
    hotelPanel: {
        marginBottom: '20px',
        marginTop: '10px',
        '& h2': {
            margin: 0,
            textTransform: 'uppercase',
            backgroundColor: theme.palette.secondary.main,
            width: '100%',
            height: '40px',
            lineHeight: '40px',
            verticalAlign: 'middle',
            paddingLeft: '15px',
            color: '#fff',
            fontSize: '14px',
            fontWeight: 'bold',
        }
    },
    hotelPanelHeder: {
        '& h2': {
            margin: 0,
            textTransform: 'uppercase',
            backgroundColor: theme.palette.secondary.main,
            width: '100%',
            height: '40px',
            lineHeight: '40px',
            verticalAlign: 'middle',
            paddingLeft: '15px',
            color: '#fff',
            fontSize: '14px',
            fontWeight: 'bold',
        }
    },
    order: {
    //display: 'none',
    },
    valueGeneral: {
        display: 'table-row',
        '& span': {
            display: 'table-cell',
            '&:first-child': {
                fontSize: '16px',
                fontWeight: 'bold',
            },
            '&:last-child': {
                fontSize: '24px',
                fontWeight: 'bold',
                textAlign: 'right',
            },
        }
    },
    valueSingle: {
        display: 'table-row',
        '& span': {
            display: 'table-cell',
            '&:first-child': {
                fontSize: '12px',
                fontWeight: 'normal',
            },
            '&:last-child': {
                fontSize: '16px',
                fontWeight: 'bold',
                textAlign: 'left',
                paddingLeft: '14px',
            },
        }
    },
    infoOrder: {
        fontSize: '12px',
        paddingTop: '10px',
    },
    orderHotel: {
        fontWeight: 'bold',
        fontSize: '16px',
        display: 'block',
        lineHeight: 2,
    },
    textGrey: {
        color: '#838383',
        display: 'block',
        lineHeight: 2,
    },
    textGreyUpper: {
        color: '#838383',
        display: 'block',
        lineHeight: 2,
        textTransform: 'uppercase',
    },
    immediate: {
        color: '#3fb717',
        textShadow: '0 0 transparent',
        textTransform: 'uppercase',
        fontWeight: 'bold',
    },
    request: {
        fontSize: '12px',
        fontStyle: 'italic',
        margin: '10px 0',
        color: theme.palette.primary.main,
        textShadow: '0 0 transparent',
        textTransform: 'uppercase',
        fontWeight: 'bold',
    },
    orderInfoBottom: {},
    orderDelBottom: {},
    orangeCollapseLink: {
        padding: '8px 22px',
        display: 'block',
        backgroundColor: 'transparent',
    },
    caretControl: {
        color: theme.palette.primary.main,
    },
    cartTourInfoList: {
        '& hr': {
            marginTop: '20px',
            marginBottom: '20px',
            border: 0,
            borderTop: '1px solid #eee',
        }
    },
    infoListItem: {},
    infoListItemHeader: {
        color: '#6d6d6d',
        borderRight: '1px dashed #d6d6d6',
    },
    infoListItemBody: {},
    infoListItemType: {
        background: '#929292',
        color: '#fff',
        padding: '2px 8px',
        borderRadius: '4px',
        fontSize: '0.7rem',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        '& .MuiSvgIcon-root': {
            fontSize: '0.7rem'
        }
    },
    infoListItemTitle: {
        display: 'block',
        fontWeight: 600,
    },
    infoListItemSubtitle: {
        display: 'block',
    },
    infoListItemProp: {
        '&:not(:last-child)': {
            marginBottom: '0.25rem',
        }
    },
    infoListItemPropName: {
        color: '#3c3c3c',
    },
    infoListItemPropVal: {
        color: '#3c3c3c',
        textShadow: '0.2px 0 #6b6b6b',
    },
    infoListItemPropValOrderStatus: (p) => (Object.assign({}, p)),
    orderAddPoint: {
        display: 'none',
    },
    contactDetails: {
        margin: '20px',
    },
    inputs: {
        width: '40%',
        [theme.breakpoints.up("lg")]: {
            width: '30%'
        },
        '& .MuiInput-formControl': {
            display: 'flex',
        },
        '& .MuiTextField-root': {
            marginBottom: '10px',
        },
        '& .MuiFormHelperText-filled:not(.Mui-error)': {
            display: 'none',
        }
    },
    hint: {
        marginLeft: '20px',
        display: 'flex',
    },
    infoBtn: {},
    cancelCondContainer: {
        display: 'none',
    },
    makeBookingBtn: {},
    accorddionSummary: {},
    transferCost: {
        textAlign: 'center',
    },
    orderStatus: {
        textAlign: 'center',
    },
    orderExcurName: {
        width: '450px',
    },
    excurDate: {
        width: '120px',
    },
    excurType: {
        width: '120px',
    },
    excurCost: {
        width: '120px',
    },
    excurHum: {
        width: '120px',
    },
}));
export default function CartFrame(props) {
    const classes = useStyles();
    const { services, isOpen, handleClose, frameId } = props;
    const delService = (service) => {
        // пока услуга одна, поэтому просто закрываем
        handleClose();
    };
    const onClose = () => {
        if (success)
            location.reload();
        else
            handleClose();
    };
    const [success, setSucces] = useState(false);
    return (React.createElement(SnackbarProvider, { maxSnack: 3, anchorOrigin: { vertical: 'top', horizontal: 'right' } },
        React.createElement(Card, null,
            React.createElement(Container, null,
                React.createElement(Dialog, { open: isOpen, fullScreen: true },
                    React.createElement(AppBar, { color: "secondary" },
                        React.createElement(Toolbar, null,
                            React.createElement(IconButton, { edge: "end", color: "inherit", onClick: onClose, "aria-label": "close" },
                                React.createElement(Close, null)),
                            React.createElement(Container, null,
                                React.createElement(Grid, { container: true, style: { margin: 0 }, spacing: 4 },
                                    React.createElement(Grid, { item: true, xs: 12, className: classes.hotelPanelHeder },
                                        React.createElement("h2", null, _T.BOOKING_YOUR_ORDER)))))),
                    success ?
                        React.createElement(Grid, { container: true, justify: "center", alignItems: "center", style: { height: '100vmin' } },
                            React.createElement(Grid, { item: true, xs: "auto", style: { textAlign: 'center' } },
                                React.createElement(Typography, { variant: "h3", style: { marginBottom: '20px' } }, _T.FRAME_BOOKING_SENDED),
                                React.createElement(CheckCircleRounded, { htmlColor: "#3fb717", style: { fontSize: '120px' } }))) :
                        React.createElement(React.Fragment, null, (services === null || services === void 0 ? void 0 : services.length)
                            ? React.createElement(CartFrameOrder, Object.assign({}, props, { delCallback: delService, onSuccess: () => {
                                    setSucces(true);
                                    const parentFrame = _ParentFrame();
                                    parentFrame.sendMessage({ message: 'scroll', top: 0, behavior: 'smooth' });
                                } }))
                            : React.createElement("div", { style: {
                                    textAlign: 'center',
                                    margin: '50px',
                                } }, _T.CART_NO_SERVICES)))))));
}
function CartFrameOrder({ services, frameId, delCallback, price, pricePerPerson, currency, onSuccess, tempId }) {
    const classes = useStyles();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [comment, setComment] = useState('');
    const snackbar = useSnackbar();
    //const [errors, setErrors] = useState<string[]>([]);
    const bookingAvailable = useMemo(() => (services === null || services === void 0 ? void 0 : services.length) && name && email && phone, [services, name, email, phone]);
    const send = () => {
        if (!bookingAvailable) {
            snackbar.enqueueSnackbar('Please fill contactDetails', { variant: 'error', autoHideDuration: 10000 });
            return;
        }
        (() => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            let tourSvc = services.find(s => s.type == 'tour');
            let excSvc = services.find(s => s.type == 'excursion');
            let extraSvc = services.find(s => s.type == 'extra');
            let hotel = services.find(s => s.type == 'hotel');
            const r = yield api('post', `/frame/${frameId}/send-booking-request${tempId ? `?tempId=${tempId}` : ''}`, {
                name, email, phone, comment, currencyId: ((_b = (_a = tourSvc === null || tourSvc === void 0 ? void 0 : tourSvc.cartData) === null || _a === void 0 ? void 0 : _a.bookingCurrency) === null || _b === void 0 ? void 0 : _b.id) || 0,
                tour: tourSvc && {
                    accomodationIds: tourSvc.accmdVariantIds,
                    tourVariantId: tourSvc.tourVariantId,
                    excursions: tourSvc.excursions,
                    hash: tourSvc.cartData.hash,
                },
                excursion: excSvc && {
                    excursionId: excSvc.excursionId,
                    date: excSvc.date,
                    adultCount: excSvc.adultCount,
                    childAges: excSvc.childAges,
                    excursionSerialized: excSvc.excursionSerialized,
                },
                extra: extraSvc && {
                    serviceId: extraSvc.serviceId,
                    date: extraSvc.date,
                    adultCount: extraSvc.adultCount,
                    childAges: extraSvc.childAges,
                    extraSerialized: extraSvc.extraSerialized,
                },
                hotel: hotel && {
                    searchParamsSerialized: hotel.searchParamsSerialized,
                    rooms: hotel.rooms,
                }
            });
            if (r.errors) {
                for (let i = 0; i < r.errors.length; i++)
                    snackbar.enqueueSnackbar(r.errors[i], { variant: 'error', autoHideDuration: 5000 });
                //setErrors({ ...errors, ...r.errors });
            }
            else {
                onSuccess();
            }
        }))();
    };
    return (React.createElement("section", { className: classes.cart },
        React.createElement(Container, null,
            React.createElement("div", { className: classes.hotelBody },
                React.createElement(Grid, { container: true, style: { margin: 0 }, spacing: 4 },
                    React.createElement(Grid, { item: true, md: 12 },
                        React.createElement("div", { className: classes.hotelPanel },
                            React.createElement("div", { className: classes.order },
                                React.createElement(Grid, { container: true },
                                    React.createElement(Grid, { item: true, md: 4 },
                                        React.createElement("div", { className: classes.valueGeneral },
                                            React.createElement("span", null, _T.BOOKING_TOTAL_PRICE),
                                            React.createElement("span", null,
                                                price.toFixed(2),
                                                " ",
                                                currency.name)),
                                        React.createElement("div", { className: classes.valueSingle },
                                            React.createElement("span", null, _T.BOOKING_PRICE_PER_PERSON),
                                            React.createElement("span", null,
                                                pricePerPerson.toFixed(2),
                                                " ",
                                                currency.name))),
                                    React.createElement(Grid, { item: true, md: 4, className: classes.infoOrder })))),
                        services.map(s => (React.createElement(CartFrameItem, { service: s, frameId: frameId, delCallback: delCallback }))),
                        React.createElement(Accordion, { elevation: 2 },
                            React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMore, null), className: classes.accorddionSummary },
                                React.createElement(Typography, { className: classes.orangeCollapseLink, display: "block" },
                                    React.createElement("span", { className: classes.caretControl }, _T.COMMON_ADDITIONAL_REQUIREMENTS))),
                            React.createElement(AccordionDetails, null,
                                React.createElement(Grid, { container: true, spacing: 4 },
                                    React.createElement(Grid, { item: true, md: 6, xs: 12 },
                                        React.createElement(TextField, { multiline: true, fullWidth: true, variant: "outlined", label: '', value: comment, onChange: e => setComment(e.target.value) })),
                                    React.createElement(Grid, { item: true, md: 4, xs: 12 },
                                        React.createElement("p", null,
                                            "* ",
                                            _T.COMMON_ADDITIONAL_REQUIREMENTS_COMMENT)))))),
                    React.createElement(Grid, { item: true, xs: 12, className: classes.orderAddPoint }),
                    React.createElement(Grid, { item: true, xs: 12, className: classes.contactDetails },
                        React.createElement(Typography, { variant: "h3", style: { fontSize: '16px', fontWeight: 'bold', marginBottom: '25px' } }, _T.COMMON_CONTACT_DETAILS),
                        React.createElement("div", { style: { display: 'flex' } },
                            React.createElement("div", { className: classes.inputs },
                                React.createElement(TextField, { variant: "outlined", size: "small", fullWidth: true, label: _T.COMMON_NAME, required: true, type: "text", placeholder: `${_T.COMMON_NAME}*`, value: name, onChange: e => setName(e.target.value), error: !name || name.length > 50, inputProps: { maxlength: 50 } }),
                                React.createElement(TextField, { variant: "outlined", size: "small", fullWidth: true, label: _T.COMMON_EMAIL, required: true, type: "email", placeholder: `${_T.COMMON_EMAIL}*`, value: email, onChange: e => setEmail(e.target.value), error: !email || !isValidEmail(email) || email.length > 50, inputProps: { maxlength: 50 } }),
                                React.createElement(TextField, { variant: "outlined", size: "small", fullWidth: true, label: _T.COMMON_PHONE, required: true, type: "text", placeholder: `${_T.COMMON_PHONE}*`, value: phone, onChange: e => setPhone(e.target.value), error: !phone || phone.length > 20, inputProps: { maxlength: 20 } })))),
                    React.createElement(Grid, { item: true, xs: 12, className: classes.cancelCondContainer }),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Button, { disabled: !bookingAvailable, color: "secondary", variant: "contained", className: classes.makeBookingBtn, onClick: send }, _T.FRAME_SEND_BOOKING)))))));
}
function CartFrameItem({ service, frameId, delCallback }) {
    return (React.createElement(React.Fragment, null, service.type == 'tour'
        ? React.createElement(CartFrameTour, { service: service, frameId: frameId, delCallback: delCallback })
        : service.type == 'excursion'
            ? React.createElement(CartFrameExcursion, { service: service, frameId: frameId, delCallback: delCallback })
            : service.type == 'extra'
                ? React.createElement(CartFrameExtra, { service: service, frameId: frameId, delCallback: delCallback })
                : React.createElement(CartFrameHotel, { service: service, frameId: frameId, delCallback: delCallback })));
}
function CartFrameTour({ service, frameId, delCallback }) {
    var _a, _b, _c;
    //const [cartData, setCartData] = useState<CartTourData>();
    const classes = useStyles();
    const { cartData } = service;
    //useEffect(() => {
    //    (async () => {
    //        const r = await api<CartTourData, undefined>('post', `/frame/${frameId}/tour-cart`, { accomodationIds: service.accmdVariantIds, tourVariantId: service.tourVariantId, excursions: service.excursions });
    //        if (r.response)
    //            setCartData(r.response);
    //    })();
    //}, []);
    const immediateConfirm = useMemo(() => cartData === null || cartData === void 0 ? void 0 : cartData.tour.variants[0].prices.find(x => x.accomodations[0].availability == 1), [cartData === null || cartData === void 0 ? void 0 : cartData.tour.variants[0].prices]);
    const renderDateRange = (rangeStart, rangeEnd) => (React.createElement("span", null, rangeStart.isSame(rangeEnd) ? rangeStart.format('L') : `${rangeStart.format('L')} – ${rangeEnd.format('L')}`));
    const renderHotelService = (svc) => (React.createElement(Grid, { container: true, item: true, xs: 12, spacing: 4, className: classes.infoListItem },
        React.createElement(Grid, { item: true, xs: 3, className: classes.infoListItemHeader },
            React.createElement("span", { className: classes.infoListItemType },
                React.createElement("i", { className: "fa fa-moon-o mr-1" }),
                " ",
                _T.COMMON_HOTEL),
            React.createElement("span", { className: classes.infoListItemTitle }, svc.accommodation.hotelName),
            React.createElement("span", { className: classes.infoListItemSubtitle }, renderDateRange(moment(svc.beginDate), moment(svc.endDate)))),
        React.createElement(Grid, { item: true, xs: 9, className: classes.infoListItemBody },
            React.createElement("div", { className: classes.infoListItemProp },
                React.createElement("span", { className: classes.infoListItemPropName },
                    _T.COMMON_ROOM_CATEGORY,
                    ": "),
                React.createElement("span", { className: classes.infoListItemPropVal },
                    svc.accommodation.roomTypeName,
                    ", ",
                    svc.accommodation.roomCategoryName)),
            React.createElement("div", { className: classes.infoListItemProp },
                React.createElement("span", { className: classes.infoListItemPropName },
                    _T.COMMON_MEAL,
                    ": "),
                React.createElement("span", { className: classes.infoListItemPropVal }, svc.accommodation.mealTypeName)),
            React.createElement("div", { className: classes.infoListItemProp },
                React.createElement("span", { className: classes.infoListItemPropName },
                    _T.COMMON_AVAILABILITY,
                    ": "),
                React.createElement("span", { className: classes.infoListItemPropVal },
                    React.createElement("span", { className: svc.accommodation.availability == 0 ? classes.immediate : classes.request }, svc.accommodation.availability == 0 ? _T.ROOM_AVAILABLE : _T.ROOM_ONREQUEST))))));
    const renderTransferService = (svc) => (React.createElement(Grid, { container: true, item: true, xs: 12, spacing: 4, className: classes.infoListItem },
        React.createElement(Grid, { item: true, xs: 3, className: classes.infoListItemHeader },
            React.createElement("span", { className: classes.infoListItemType },
                React.createElement("i", { className: "fa fa-cab mr-1" }),
                " ",
                _T.COMMON_TRANSFER),
            React.createElement("span", { className: classes.infoListItemTitle }, svc.name),
            React.createElement("span", { className: classes.infoListItemSubtitle }, renderDateRange(moment(svc.beginDate), moment(svc.endDate)))),
        React.createElement(Grid, { item: true, xs: 9, className: classes.infoListItemBody },
            React.createElement("div", { className: classes.infoListItemProp },
                React.createElement("span", { className: classes.infoListItemPropName },
                    _T.COMMON_ROUTE,
                    ": "),
                React.createElement("span", { className: classes.infoListItemPropVal },
                    svc.cityFrom.name,
                    " (",
                    svc.placeFrom.name,
                    ") \u2192 ",
                    svc.cityTo.name,
                    " (",
                    svc.placeTo.name,
                    ")")),
            React.createElement("div", { className: classes.infoListItemProp },
                React.createElement("span", { className: classes.infoListItemPropName },
                    _T.TRANSFER_TYPE,
                    ": "),
                React.createElement("span", { className: classes.infoListItemPropVal }, svc.transferType.name)))));
    const renderExtraService = (svc) => (React.createElement(Grid, { container: true, item: true, xs: 12, spacing: 4, className: classes.infoListItem },
        React.createElement(Grid, { item: true, xs: 3, className: classes.infoListItemHeader },
            React.createElement("span", { className: classes.infoListItemType },
                React.createElement("i", { className: "fa fa-plus mr-1" }),
                " ",
                _T.COMMON_EXTRA_SERVICES),
            React.createElement("span", { className: classes.infoListItemTitle }, svc.name),
            React.createElement("span", { className: classes.infoListItemSubtitle }, renderDateRange(moment(svc.beginDate), moment(svc.endDate)))),
        React.createElement(Grid, { item: true, xs: 9, className: classes.infoListItemBody })));
    const renderExcursionService = (svc) => (React.createElement(Grid, { container: true, item: true, xs: 12, spacing: 4, className: classes.infoListItem },
        React.createElement(Grid, { item: true, xs: 3, className: classes.infoListItemHeader },
            React.createElement("span", { className: classes.infoListItemType },
                React.createElement("i", { className: "fa fa-map mr-1" }),
                " ",
                _T.COMMON_EXCURSION),
            React.createElement("span", { className: classes.infoListItemTitle }, svc.name),
            React.createElement("span", { className: classes.infoListItemSubtitle }, renderDateRange(moment(svc.beginDate), moment(svc.endDate)))),
        React.createElement(Grid, { item: true, xs: 9, className: classes.infoListItemBody })));
    const renderFlightService = (svc) => (React.createElement(Grid, { container: true, item: true, xs: 12, spacing: 4, className: classes.infoListItem },
        React.createElement(Grid, { item: true, xs: 3, className: classes.infoListItemHeader },
            React.createElement("span", { className: classes.infoListItemType },
                React.createElement("i", { className: "fa fa-plane mr-1" }),
                " ",
                _T.COMMON_FLIGHT),
            React.createElement("span", { className: classes.infoListItemTitle }, svc.name),
            React.createElement("span", { className: classes.infoListItemSubtitle }, renderDateRange(moment(svc.beginDate), moment(svc.endDate)))),
        React.createElement(Grid, { item: true, xs: 9, className: classes.infoListItemBody },
            React.createElement("div", { className: classes.infoListItemProp },
                React.createElement("span", { className: classes.infoListItemPropName },
                    _T.COMMON_ROUTE,
                    ": "),
                React.createElement("span", { className: classes.infoListItemPropVal },
                    svc.cityFrom.name,
                    " \u2192 ",
                    svc.cityTo.name)),
            React.createElement("div", { className: classes.infoListItemProp },
                React.createElement("span", { className: classes.infoListItemPropName },
                    _T.FLIGHT_CLASS,
                    ": "),
                React.createElement("span", { className: classes.infoListItemPropVal }, svc.flightClass.name)))));
    return (React.createElement(React.Fragment, null, cartData ?
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.tableResponsive },
                React.createElement("table", { className: classes.orderTable },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { className: classes.tourOrderTableTourname },
                                React.createElement("img", { src: appUrl('/Content/img/icon_tour.png') }),
                                " ",
                                _T.COMMON_TOUR),
                            React.createElement("th", { className: classes.tourOrderTableCheckindate }, _T.COMMON_CHECKIN),
                            React.createElement("th", { className: classes.tourOrderTableCheckoutdate }, _T.COMMON_CHECKOUT),
                            React.createElement("th", { className: classes.tourOrderTableDuration }, _T.COMMON_DURATION),
                            React.createElement("th", { className: classes.tourOrderTablePrice }, _T.BOOKING_TOTAL_PRICE),
                            React.createElement("th", { className: classes.tourOrderTablePersons }, _T.COMMON_PERSONCOUNT),
                            React.createElement("th", { className: classes.tourOrderTableAvailability }, _T.COMMON_AVAILABILITY))),
                    React.createElement("tbody", null,
                        React.createElement("tr", { className: classes.orderInfo, id: `tourServiceRow${cartData.id}` },
                            React.createElement("td", { className: classes.tourOrderTableTourname },
                                React.createElement("span", { className: classes.orderHotel }, cartData.tour.name),
                                ((_c = (_b = (_a = cartData.tour.variants[0]) === null || _a === void 0 ? void 0 : _a.prices[0]) === null || _b === void 0 ? void 0 : _b.accomodations) === null || _c === void 0 ? void 0 : _c.length) === 1
                                    ? React.createElement("span", { className: classes.textGrey },
                                        cartData.tour.variants[0].prices[0].accomodations[0].countryName,
                                        ",",
                                        cartData.tour.variants[0].prices[0].accomodations[0].cityName)
                                    : null),
                            React.createElement("td", { className: classes.tourOrderTableCheckindate },
                                moment(cartData.begin).format('L'),
                                React.createElement("span", { className: classes.textGreyUpper }, moment(cartData.begin).format('ddd'))),
                            React.createElement("td", { className: classes.tourOrderTableCheckoutdate },
                                moment(cartData.end).format('L'),
                                React.createElement("span", { className: classes.textGreyUpper }, moment(cartData.end).format('ddd'))),
                            React.createElement("td", { className: classes.tourOrderTableDuration },
                                cartData.tour.durationDays,
                                " ",
                                pluralizeDays(cartData.tour.durationDays)),
                            React.createElement("td", { className: classes.tourOrderTablePrice },
                                cartData.priceInBookingCurrency.toFixed(2),
                                " ",
                                cartData.bookingCurrency.name),
                            React.createElement("td", { className: classes.tourOrderTablePersons },
                                cartData.accommodation.adults + cartData.accommodation.childs,
                                " ",
                                pluralizePersons(cartData.accommodation.adults + cartData.accommodation.childs)),
                            React.createElement("td", { className: classes.tourOrderTableAvailability },
                                React.createElement("span", { className: immediateConfirm ? classes.immediate : classes.request }, immediateConfirm ? _T.ROOM_AVAILABLE : _T.ROOM_ONREQUEST))),
                        React.createElement("tr", { className: classes.orderInfoBottom },
                            React.createElement("td", null),
                            React.createElement("td", { colSpan: 5 }),
                            React.createElement("td", { className: classes.orderDelBottom },
                                React.createElement(Button, { variant: "text", onClick: () => delCallback(service) }, _T.BOOKING_DELETE_SERVICE)))))),
            React.createElement(Accordion, { elevation: 2 },
                React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMore, null), className: classes.accorddionSummary },
                    React.createElement(Typography, { className: classes.orangeCollapseLink, display: "block" },
                        React.createElement("span", { className: classes.caretControl }, _T.BOOKING_TOUR_INFORMATION))),
                React.createElement(AccordionDetails, null,
                    React.createElement(Grid, { container: true, className: classes.cartTourInfoList },
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement("hr", null)),
                        cartData.allTourServices.map(tourSvc => (React.createElement(React.Fragment, null,
                            tourSvc.type == 'hotel' ?
                                renderHotelService(tourSvc) :
                                tourSvc.type == 'transfer' ?
                                    renderTransferService(tourSvc) :
                                    tourSvc.type == 'extra' ?
                                        renderExtraService(tourSvc) :
                                        tourSvc.type == 'excursion' ?
                                            renderExcursionService(tourSvc) :
                                            tourSvc.type == 'flight' ?
                                                renderFlightService(tourSvc) :
                                                React.createElement(React.Fragment, null),
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement("hr", null)))))))))
        : React.createElement("div", null)));
}
function CartFrameExcursion({ service, frameId, delCallback }) {
    var _a, _b, _c, _d;
    const classes = useStyles();
    const { cartData } = service;
    return (React.createElement(React.Fragment, null, cartData ?
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.tableResponsive },
                React.createElement("table", { className: classes.orderTable },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null,
                                React.createElement("img", { src: appUrl('/Content/img/icon_exkurze.png') }),
                                " ",
                                _T.COMMON_EXCURSIONS),
                            React.createElement("th", null, _T.COMMON_DATE),
                            React.createElement("th", null, _T.EXCURSION_TYPE),
                            React.createElement("th", { className: classes.transferCost }, _T.BOOKING_TOTAL_PRICE),
                            React.createElement("th", null, _T.COMMON_PERSONCOUNT),
                            React.createElement("th", { className: classes.orderStatus }, _T.COMMON_AVAILABILITY))),
                    React.createElement("tbody", null,
                        React.createElement("tr", { className: classes.orderInfo, id: `transferServiceRow${cartData.id}` },
                            React.createElement("td", { className: classes.orderExcurName },
                                React.createElement("span", { className: classes.orderHotel }, cartData.name),
                                cartData.excursionProgramPrice
                                    ? cartData.excursionProgramPrice.excursionPrices.map((e, i) => (React.createElement("p", null,
                                        i + 1,
                                        ") ",
                                        e.name,
                                        React.createElement("br", null),
                                        e.excursionTypeName,
                                        React.createElement("br", null),
                                        moment(e.date).format(`L ddd [, ${_T.COMMON_BEGIN_AT}] HH:mm`))))
                                    : null),
                            React.createElement("td", { className: classes.excurDate },
                                moment(cartData.begin).format('L'),
                                React.createElement("span", { className: classes.textGreyUpper }, moment(cartData.begin).format('ddd'))),
                            React.createElement("td", { className: classes.excurType },
                                React.createElement("span", { style: { textTransform: 'uppercase' } }, (_b = (_a = cartData.excursionPrice) === null || _a === void 0 ? void 0 : _a.excursionTypeName) !== null && _b !== void 0 ? _b : `&mdash;`),
                                React.createElement("div", { style: { textTransform: 'uppercase' } },
                                    React.createElement("span", { className: classes.textGreyUpper }, (_d = (_c = cartData.excursionPrice) === null || _c === void 0 ? void 0 : _c.vehicleTypeName) !== null && _d !== void 0 ? _d : ``))),
                            React.createElement("td", { className: classes.excurCost },
                                cartData.priceInBookingCurrency.toFixed(2),
                                " ",
                                cartData.bookingCurrency.name),
                            React.createElement("td", { className: classes.excurHum },
                                cartData.accommodation.adults + cartData.accommodation.childs,
                                " ",
                                pluralizePersons(cartData.accommodation.adults + cartData.accommodation.childs)),
                            React.createElement("td", { className: classes.orderStatus },
                                React.createElement("span", { className: classes.immediate }, _T.ROOM_AVAILABLE))),
                        React.createElement("tr", { className: classes.orderInfoBottom },
                            React.createElement("td", { colSpan: 5 }),
                            React.createElement("td", { className: classes.orderDelBottom },
                                React.createElement(Button, { variant: "text", onClick: () => delCallback(service) }, _T.BOOKING_DELETE_SERVICE)))))))
        : React.createElement("div", null)));
}
function CartFrameExtra({ service, frameId, delCallback }) {
    var _a, _b, _c;
    const classes = useStyles();
    const { cartData } = service;
    return (React.createElement(React.Fragment, null, cartData ?
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.tableResponsive },
                React.createElement("table", { className: classes.orderTable },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null,
                                React.createElement("img", { src: appUrl('/Content/img/icon_exkurze.png') }),
                                " ",
                                _T.COMMON_EXTRA_SERVICES),
                            React.createElement("th", null, _T.COMMON_DATE),
                            React.createElement("th", null, _T.COMMON_EXTRA_CLASS),
                            React.createElement("th", { className: classes.transferCost }, _T.BOOKING_TOTAL_PRICE),
                            React.createElement("th", null, _T.COMMON_PERSONCOUNT),
                            React.createElement("th", { className: classes.orderStatus }, _T.COMMON_AVAILABILITY))),
                    React.createElement("tbody", null,
                        React.createElement("tr", { className: classes.orderInfo, id: `transferServiceRow${cartData.id}` },
                            React.createElement("td", { className: classes.orderExcurName },
                                React.createElement("span", { className: classes.orderHotel }, (_a = cartData.extraPrice) === null || _a === void 0 ? void 0 : _a.name)),
                            React.createElement("td", { className: classes.excurDate },
                                moment(cartData.begin).format('L'),
                                React.createElement("span", { className: classes.textGreyUpper }, moment(cartData.begin).format('ddd'))),
                            React.createElement("td", { className: classes.excurType },
                                React.createElement("span", { style: { textTransform: 'uppercase' } }, (_c = (_b = cartData.extraPrice) === null || _b === void 0 ? void 0 : _b.serviceClassName) !== null && _c !== void 0 ? _c : `&mdash;`)),
                            React.createElement("td", { className: classes.excurCost },
                                cartData.priceInBookingCurrency.toFixed(2),
                                " ",
                                cartData.bookingCurrency.name),
                            React.createElement("td", { className: classes.excurHum },
                                cartData.accommodation.adults + cartData.accommodation.childs,
                                " ",
                                pluralizePersons(cartData.accommodation.adults + cartData.accommodation.childs)),
                            React.createElement("td", { className: classes.orderStatus },
                                React.createElement("span", { className: classes.immediate }, _T.ROOM_AVAILABLE))),
                        React.createElement("tr", { className: classes.orderInfoBottom },
                            React.createElement("td", { colSpan: 5 }),
                            React.createElement("td", { className: classes.orderDelBottom },
                                React.createElement(Button, { variant: "text", onClick: () => delCallback(service) }, _T.BOOKING_DELETE_SERVICE)))))))
        : React.createElement("div", null)));
}
function CartFrameHotel({ service, frameId, delCallback }) {
    var _a;
    const classes = useStyles();
    return (React.createElement(React.Fragment, null, ((_a = service.cartData) === null || _a === void 0 ? void 0 : _a.length) ? React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.tableResponsive },
            React.createElement("table", { className: classes.orderTable },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null,
                            React.createElement("img", { src: appUrl('/Content/img/icon_hotel.png') }),
                            " ",
                            _T.COMMON_STAY),
                        React.createElement("th", null, _T.COMMON_CHECKIN),
                        React.createElement("th", null, _T.COMMON_CHECKOUT),
                        React.createElement("th", null, _T.COMMON_HOTELROOM),
                        React.createElement("th", null, _T.COMMON_MEAL),
                        React.createElement("th", null, _T.BOOKING_TOTAL_PRICE),
                        React.createElement("th", null, _T.COMMON_PERSONCOUNT),
                        React.createElement("th", { className: classes.orderStatus }, _T.COMMON_AVAILABILITY))),
                React.createElement("tbody", null, service.cartData.map(cartData => {
                    var _a, _b, _c;
                    const compulsorySvcs = (_a = service.cartDataCompulsory) === null || _a === void 0 ? void 0 : _a.filter(x => x.serviceTag == cartData.serviceTag);
                    return (React.createElement(React.Fragment, null,
                        React.createElement("tr", { className: classes.orderInfo, id: `hotelServiceRow${cartData.id}` },
                            React.createElement("td", null,
                                React.createElement("span", { className: classes.orderHotel }, (_c = (_b = cartData.hotel) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : cartData.hotelPrice.hotelName)),
                            React.createElement("td", null,
                                moment(cartData.begin).format('L'),
                                React.createElement("span", { className: classes.textGreyUpper }, moment(cartData.begin).format('ddd'))),
                            React.createElement("td", null,
                                moment(cartData.end).format('L'),
                                React.createElement("span", { className: classes.textGreyUpper }, moment(cartData.end).format('ddd'))),
                            React.createElement("td", null,
                                React.createElement("span", { className: "text-uppercase" },
                                    React.createElement("b", null,
                                        cartData.hotelPrice.roomType.name,
                                        " ",
                                        cartData.hotelPrice.roomCategory.name)),
                                React.createElement("span", { className: "text-grey" },
                                    cartData.accommodation.adults,
                                    " ",
                                    _T.COMMON_ADULT_SHORT,
                                    " ",
                                    cartData.accommodation.childs > 0 ? (`${cartData.accommodation.childs} ${_T.COMMON_CHILD_SHORT}`) : null)),
                            React.createElement("td", null,
                                cartData.priceInBookingCurrency.toFixed(2),
                                " ",
                                cartData.bookingCurrency.name),
                            React.createElement("td", null,
                                cartData.accommodation.adults + cartData.accommodation.childs,
                                " ",
                                pluralizePersons(cartData.accommodation.adults + cartData.accommodation.childs)),
                            React.createElement("td", { className: classes.orderStatus },
                                React.createElement("span", { className: classes.immediate }, cartData.hotelPrice.immediateConfirm ? _T.ROOM_AVAILABLE : _T.ROOM_ONREQUEST))),
                        (compulsorySvcs === null || compulsorySvcs === void 0 ? void 0 : compulsorySvcs.length) ? React.createElement(React.Fragment, null,
                            React.createElement("tr", { className: "spanner", "data-compsvc-part": cartData.serviceTag },
                                React.createElement("td", { colSpan: 8 })),
                            React.createElement("tr", { className: "compulsory-services-header", "data-compsvc-part": cartData.serviceTag },
                                React.createElement("td", null, _T.HOTEL_COMPUSORY_SERVICES),
                                React.createElement("td", { colSpan: 2 }, _T.COMMON_DATE),
                                React.createElement("td", { colSpan: 2 }, _T.COMMON_SERVICE),
                                React.createElement("td", null, _T.HOTEL_COMPULSORY_SERVICE_PRICE),
                                React.createElement("td", { colSpan: 2 }, _T.COMMON_PERSONCOUNT)),
                            compulsorySvcs.map(compSvc => React.createElement(React.Fragment, null,
                                React.createElement("tr", { id: `compulsory-service-${compSvc.serviceTag}`, className: "compulsory-services-body ajax-replace", "data-compsvc-part": cartData.serviceTag },
                                    React.createElement("td", null, "\u00A0"),
                                    React.createElement("td", { colSpan: 2 }, moment(compSvc.begin).format('L')),
                                    React.createElement("td", { colSpan: 2 }, compSvc.compulsoryService.name),
                                    React.createElement("td", null,
                                        compSvc.priceInBookingCurrency.toFixed(2),
                                        " ",
                                        cartData.bookingCurrency.name),
                                    React.createElement("td", { colSpan: 2 },
                                        compSvc.accommodation.adults + compSvc.accommodation.childs,
                                        " ",
                                        pluralizePersons(compSvc.accommodation.adults + compSvc.accommodation.childs)))))) : null,
                        React.createElement("tr", { className: classes.orderInfoBottom },
                            React.createElement("td", { colSpan: 5 }),
                            React.createElement("td", { className: classes.orderDelBottom },
                                React.createElement(Button, { variant: "text", onClick: () => delCallback(service) }, _T.BOOKING_DELETE_SERVICE)))));
                }))))) : React.createElement("div", null)));
}
